import { useBlocker } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';

function doNothing(): void {}

export function useNavigationBlocker({ when }: { when: boolean }) {
  const shouldBlockFn = useCallback(() => when, [when]);
  const blocker = useBlocker({ disabled: !when, enableBeforeUnload: when, shouldBlockFn, withResolver: true });

  useEffect(() => {
    if (when || blocker.status !== 'blocked') return;
    blocker.reset();
  }, [blocker, when]);

  const isBlocked = blocker.status === 'blocked';
  return { abort: isBlocked ? blocker.reset : doNothing, confirm: isBlocked ? blocker.proceed : doNothing, isBlocked };
}
